export default __webpack_public_path__ + "static/media/9400eed47b613db2d1baa79957124462.svg";